// ルーティング時の画面識別名。router の `name` 指定と一致させること。
export const OPERATOR_LIST_FILE_NAME = "OperatorList";
